// web/src/api/currency/CurrencyAPI.ts
import { AxiosInstance } from 'axios';

export default class CurrencyAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getCurrencies() {
    return this.client.get('/currency/get-currencies');
  }

  async getFilteredCurrencies() {
    return this.client.get('/currency/get-filtered-currencies');
  }

  async getMarketDataCurrencies() {
    return this.client.get('/v2/market-data/currencies');
  }
}
